import Dexie from 'dexie';

const db = new Dexie('insiderTransactions');

db.version(1).stores({
  filters: '++id, &identifier, filters',
});

const filters = new Map();

export const getSavedFilters = async (identifier, key = null) => {
  const [dbTopicFilters] = await db.filters.where({
    identifier,
  }).toArray();

  if (!dbTopicFilters) {
    return key !== null ? null : {};
  }
  const topicFilters = JSON.parse(dbTopicFilters.filters);

  filters.set(identifier, topicFilters);

  return (
    key !== null ? topicFilters[key] : topicFilters
  );
};

export const setFilter = async (identifier, key, value) => {
  if (!filters.has(identifier)) {
    filters.set(identifier, {});
  }
  const topicFilters = filters.get(identifier);

  topicFilters[key] = value;

  let [dbTopicFilters] = await db.filters.where({
    identifier,
  }).toArray();

  if (dbTopicFilters) {
    dbTopicFilters.filters = JSON.stringify(topicFilters);
  } else {
    dbTopicFilters = {
      identifier,
      filters: JSON.stringify(topicFilters),
    };
  }

  db.filters.put(dbTopicFilters);
};
